module.exports = __webpack_public_path__ + "img/no-image3.a0ba239f.png";